<manage-wrapper
  *ngIf="!!performer && { brief: performerBriefs[this.performer.id] } as p"
  [canEditMain]="!data.readOnly"
  [entityTitle]="performer.name"
  [topToggleText]="'SHOW IN PUBLISH'"
  [topToggled]="!performer.hideInPublish"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="data.readOnly"
  [labels]="performer.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [deleteTitle]="'Delete this Performer'"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [clipLabel]="clipLabel"
  [type]="'performer'"
  [titlePlaceholder]="'Performer name'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Manage Performer'"
  [canDuplicate]="false"
  [showStars]="true"
  [stars]="performer.stars || 0"
  (saveStars)="saveStars($event)"
  (onToggle)="changeHideInPublish()"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
  (onDelete)="delete()"
  (onClip)="clip()"
>
  <entity-types class="afterTitle"
    [readOnly]="data.readOnly"
    [entityType]="'performer'"
    [entity]="performer"
  ></entity-types>
  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.details">
    <div class="toggle-holder inner-toggle">
      <div style="flex:1;"></div>
      <toggle-tab class="inner-toggle" [bottomTab]="false" [hideToggle]="data.readOnly" [text]="'PROFILE ' + (performer.confirmed ? '' : 'NOT ') + 'CONFIRMED'" [toggled]="!!performer.confirmed" (toggle)="toggleProfileConfirmed()"></toggle-tab>
    </div>
    <tip-text class="top" *ngIf="performerShareable && performerShareable.status == 'Active'" [type]="'warn'" [head]="'Attention:'" [body]="'This performer has an active webform to edit profile information.'"></tip-text>
    <tip-text class="top" *ngIf="!performerShareable || performerShareable.status != 'Active'" [type]="'tip'" [head]="'Tip:'" [body]="'Performers can submit their profile information using a shareable link by turning on the <strong>Profile webform for editing</strong> below.'"></tip-text>

    <div>Share webform to receive performer profile information.</div>
    <binary-share-toggle
      style="display: block; margin-bottom: 20px;"
      [type]="'profile'"
      [shareType]="shareTypes.profile"
      [shareableFormat]="'oneLine'"
      [hideBottom]="!performerShareable"
      [shareCode]="performerShareable?.code"
      [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
      [title]="'Profile webform'"
      [shareTitle]="'Your shareable webform:'"
      [generatingCode]="generatingPerformerEditCode"
      [status]="performerShareable?.status || 'Off'"
      (toggle)="toggleProfileShareable()"
      (changeStatus)="changeProfileShareableStatus($event)"
    ></binary-share-toggle>

    <div class="uploaders-holder">
      <image-uploader 
        [id]="performer.id"
        (newUrls)="changeImage($event, 'photo')"
        [immediate]="true" 
        [isLogo]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="performer.photoUrl" 
        [photoUrl]="performer.fullPhotoUrl"
        [eventId]="event?.eventId"
        [type]="'performer'" 
        [subtype]="'photo'" 
        [placeholder]="'Add photo'" 
        [uploadText]="'UPLOAD PHOTO'"
        [saveName]="performer.name"
      ></image-uploader>
      <image-uploader 
        [id]="performer.id"
        (newUrls)="changeImage($event, 'logo')"
        [immediate]="true" 
        [isLogo]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="performer.logoUrl" 
        [photoUrl]="performer.fullLogoUrl"
        [eventId]="event?.eventId"
        [type]="'performer'" 
        [subtype]="'logo'" 
        [placeholder]="'Add logo'" 
        [uploadText]="'UPLOAD LOGO'"
        [saveName]="performer.name"
      ></image-uploader>
    </div>

    <h3 class="description-title">Line 1 (e.g. job title)</h3>
    <joi-input class="description" [disabled]="data.readOnly" [italicPlaceholder]="true" [(model)]="performer.line1" [placeholder]="'Click to add line 1...'" (joiChange)="savePerformer()"></joi-input>

    <h3 class="description-title">Line 2 (e.g. company)</h3>
    <joi-input class="description" [disabled]="data.readOnly" [italicPlaceholder]="true" [(model)]="performer.line2" [placeholder]="'Click to add line 2...'" (joiChange)="savePerformer()"></joi-input>

    <manage-social [links]="performer?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <h3 class="description-title">Bio</h3>
    <!--<joi-input class="description" [disabled]="data.readOnly" [italicPlaceholder]="true" [(model)]="performer.bio" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add a bio...'" (joiChange)="savePerformer()"></joi-input>
-->
    <input-editor 
      [disabled]="data.readOnly"
      [object]="performer" 
      [prop]="'bio'" 
      [placeholder]="'Click to add a bio...'"
      (keyup)="keyup($event)"
      (changed)="savePerformer()"
    ></input-editor>
    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="performer"
      [entityName]="'Performer'"
      [nameProp]="'contactName'"
      [numberProp]="'phone'"
      [emailProp]="'email'"
      [readOnly]="data.readOnly"
      (contactDetailsChanged)="savePerformer()"
    ></manage-contact-details>

    <custom-questions-app
      [entity]="performer"
      [entityType]="'performer'"
      (updateQuestion)="updateCustomQuestion($event)"
    ></custom-questions-app>

  </ng-container>

<ng-container *ngIf="selectedTab?.id === tabs.sessions">  
  <add-manage-wrapper [hideHRule]="true" class="session-list" [openLabel]="sessionProgramList.length && !data.readOnly ? '+ ADD TO A SESSION' : ''" (open)="sessionProgramList.length ? addToASession($event) : null">
    <div class="session-message">
      <div *ngIf="!performerTableData?.nestedIds.length" class="empty-text">This performer is not assigned to any sessions.</div>
      <ng-container *ngIf="performerTableData?.nestedIds.length">
        <traffic-light *ngFor="let light of performerTableData.status.lights" [color]="light.color" [text]="light.text"></traffic-light>
      </ng-container>
    </div>

    <status-wrapper *ngFor="let session of sessionList"
      class="sessions"
      [status]="session.status"
      [ngClass]="{ clickable: !data.readOnly }"
      (click)="data.readOnly ? null : manageSession(session)"
      [briefStatus]="session.briefStatus || briefStatus.NotBriefed || null"
      [deleteTitle]="'Remove ' + performer.name + ' from this session'"
      [wideFormat]="true"
      [readOnly]="data.readOnly"
      [threeDotOptions]="threeDotSessionOptions"
      (changeStatus)="changeStatus(session, $event)"
      (threeDotSelection)="sessionDotMenuSelection($event, session)"
      (changeBriefStatus)="changeBriefStatus(session, $event)"
    >
      
      <big-and-grey class="wideContent" [theTitle]="session.title" greyText="{{ session.start }} - {{ session.end }}, {{ (session.day ? session.day : session.date | date: 'd MMMM y') }}" ></big-and-grey>
      <div class="wideContentInnerRight" *ngIf="!!session && !!event && performerRoles">
        <performer-role-editor [programId]="session.programId" [session]="session.fullSession" [performerId]="performer.id" [event]="event" [readOnly]="data.readOnly"
          [role]="performerRoles && session?.fullSession?.performerRoles ? performerRoles[session.fullSession.performerRoles[performer.id]] : null"></performer-role-editor>
        <!-- <ng-container *ngIf="!!sessionId" [ngTemplateOutlet]="performerRole" [ngTemplateOutletContext]="{ performerId: performer.id }"></ng-container>-->         
      </div>
    </status-wrapper>
  </add-manage-wrapper>

</ng-container>

<ng-container *ngIf="selectedTab?.id === tabs.contact">
  <tip-text class="top" [type]="'tip'" [head]="'Tip:'" [body]="'The workforce contact will appear in the performer brief.'"></tip-text>
  <manage-contact
    [workforceContactEmail]="performer?.contact" 
    [readOnly]="data.readOnly"
    (changeContact)="changeWorkforceContact($event)"
  ></manage-contact>
</ng-container>

<ng-container *ngIf="selectedTab?.id === tabs.quickNotes">
  <chat-box [isNotes]="true" [comments]="performer.quickNotes || []" [readOnly]="data.readOnly" (quickNotesChanged)="saveQuickNotes($event)" ></chat-box>
</ng-container>

<entity-tasks *ngIf="selectedTab?.id === tabs.tasks" [entity]="performer" [changeDetectorRef]="changeDetectorRef"></entity-tasks>

<ng-container *ngIf="selectedTab?.id === tabs.infoForPerformer">
  <tip-text class="top" [head]="'Tip:'" [body]="'You can manage general performer and program information that appears for all performers in <strong>Set Up</strong>.'"></tip-text>
  <title-icon [titleIcon]="'description18'" [title]="'Information for '+performer.name+' only'"></title-icon>
  <div class="empty-text">Add information or instructions specific to this performer</div>
  <informable 
    [singleSectionOnly]="true"
    [readonly]="data.readOnly"
    [informableType]="'performer'" 
    [informableKey]="data.performerId" 
    [noItemsMessage]="''"
    ></informable>
</ng-container>

<ng-container *ngIf="selectedTab?.id === tabs.assets">
  <assets 
    [title]="'Associated Assets'"
    [associatedId]="performer.id"
    [assetIds]="associatedAssetIds"
    [entityHolderName]="'performer'"
    [readOnly]="data.readOnly"
  ></assets>

  <ng-container *ngIf="!data.readOnly">
    <edit-associated-assets-manager *ngIf="!!performer" style="margin-top: 30px;"
      [type]="'performer'"
      [entity]="performer"
      [view]="'shareable'"
    ></edit-associated-assets-manager>
  </ng-container>

</ng-container>

<ng-container *ngIf="selectedTab?.id === tabs.schedule">
  <app-brief *ngIf="!!event && !!performer"
    [performer]="performer"
    [briefType]="'performer'"
    [briefInfo]="p.brief"
    [timelineOnly]="true"
  ></app-brief>
</ng-container>

<ng-container *ngIf="selectedTab?.id === tabs.configBrief">
  <h3 style="padding: 20px 0 ; ">Configure actions to include in {{ performer.name }}'s performer brief</h3>
  <tip-text class="top" [type]="'important'" [head]="'Important'" [body]="'Actions will automatically appear in '+ performer.name +'\'s Performer Brief when the below configurations are set to &ldquo;ON&rdquo;'"></tip-text>
  <h5 class="subtitle">PROFILE</h5>
  <add-link-to-brief-wrapper
    [title]="'<strong>Include profile webform</strong>'"
    [toggleOn] = "performer.showEditProfileLinkInPerformerBrief"
    [disabled] = "data.readOnly"
    [selected] = "performerShareable?.status || 'Off'"
    (toggle)="updateShowEditProfileLinkInPerformerBrief()"
    (toggleStatus)="changeProfileShareableStatus($event)"
  ></add-link-to-brief-wrapper>

  <edit-associated-assets-manager *ngIf="!!performer" style="margin-top: 30px;"
    [type]="'performer'"
    [entity]="performer"
    [view]="'actions'"
    (toggleShowEditAssetsLinkInBrief)="performer.showAssetsLinkInBrief = $event; savePerformer()"
  ></edit-associated-assets-manager> 

  <h5 class="subtitle" style="padding-top: 30px;">SESSIONS</h5>
  <div *ngIf="!performerTableData?.nestedIds.length" class="empty-text">This performer is not assigned to any sessions.</div>

  <grey-wrapper *ngFor="let session of sessionList" class="sessions" >
    <big-and-grey 
      class="wideContent" 
      [theTitle]="session.title" 
      greyText="{{session.duration}} minutes | {{ session.start }} - {{ session.end }}, {{ (session.day ? session.day : session.date | date: 'd MMMM y') }} | {{ session.programTitle }}" 
    ></big-and-grey>
    <ng-container *ngIf="shareableSynopsis[session.id] || { performerId: null, status: null, performerName: null } as synopsis">
      <add-link-to-brief-wrapper
        *ngIf="{ canEdit: synopsis.performerId === performer.id && !!synopsis.status && synopsis.status !== 'Off', status: synopsis.status || 'Off', pName: synopsis.performerName || 'anyone' } as vars"
        [title]="'Receive <strong>session information</strong> '+ (vars.status !== 'Off' ? (vars.canEdit ? 'from '+ vars.pName + ' for this session' : '(active for '+ vars.pName + ')'):'(Not configured)')"
        [toggleOn] = "vars.canEdit"
        [configurable] = "true"
        [dimmed] = "!vars.canEdit"
        [disabled] = "data.readOnly"
        [selected] = "vars.status"
        (openConfigurations)="openConfigurations(session)"
        (toggleStatus)="setSessionItemStatus(session.id, session.programId, $event, 'synopsis')"
      ></add-link-to-brief-wrapper>
    </ng-container>
    <add-link-to-brief-wrapper
      [title]="'Receive <strong>staging requests</strong> from '+performer.name+' for this session'"
      [toggleOn] = "!!shareableStagingRequest[session.id+'_'+performer.id] && shareableStagingRequest[session.id+'_'+performer.id].status !== 'Off'"
      [disabled] = "data.readOnly"
      [selected] = "shareableStagingRequest[session.id+'_'+performer.id]?.status || 'Off'"
      (toggle)="setSessionItemStatus(session.id, session.programId, $event ? 'Active' : 'Off', 'stagingRequest')"
      (toggleStatus)="setSessionItemStatus(session.id, session.programId, $event, 'stagingRequest')"
    ></add-link-to-brief-wrapper>
  </grey-wrapper>


  <manage-terms 
    [entity]="performer" 
    [readOnly]="data.readOnly" 
    (saveEntity)="savePerformer()"
  ></manage-terms>

</ng-container>


<ng-container *ngIf="selectedTab?.id === tabs.preview && { status: performerBriefs[this.performer.id]?.status } as vars">
  <binary-share-toggle
    class="brief"
    [type]="'brief'"
    [contactName]="performer.contactName || ''"
    [contactEmail]="performer.email || ''"
    [shareType]="shareTypes.performer"
    [shareableFormat]="'oneLine'"
    [shareCode]="performerBriefs[this.performer.id]?.id"
    [hint]="'Note: The shareable webpage below is dynamic and will always load the current information for the performer.'"
    [title]="'Performer Brief webpage'"
    [shareTitle]="'Your shareable webpage:'"
    [status]="performerBriefs[this.performer.id]?.status || 'Off'"
    [alwaysOnMessage]="'Share the performer brief as a webpage.'"
    (toggle)="shareUrl($event)"
    (changeStatus)="shareUrl($event === 'Off' ? false : true)"
  ></binary-share-toggle>
  <tip-text class="top" class="brief-tip bottom" [type]="'tip'" [head]="'Tip:'" [body]="'Below is what <strong>' + performer.name + '</strong> will see when they view their brief.\n\nA performer’s brief is built automatically from other sections of Joi — for example, you can include a program and manage terms in the <strong>Information for performer brief</strong> section. Assigning a performer to a session or tagging them to an activity in <strong>On Site Schedule</strong> will populate the <strong>My Schedule</strong> section.'"></tip-text>
  <hr class="big-rule" />
  <app-brief *ngIf="!!event && !!performer"
    [performer]="performer"
    [briefType]="'performer'"
    [briefInfo]="p.brief"
  ></app-brief>
</ng-container>

</manage-wrapper>
